import React from 'react';
import { DataTable, SectionHeader } from '../components';

export function ProductsPage({ rows }) {
  return (
    <div>
      <SectionHeader
        title="Products"
        subtitle={`${rows.products?.length || 0} items in your catalog`}
      />
      <DataTable
        testid="dash-products-table"
        rows={rows.products}
        emptyText="No products yet."
        columns={[
          { key: 'name',  label: 'Name', nowrap: true },
          { key: 'kind',  label: 'Kind', nowrap: true,
            render: r => <span style={{
              padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600,
              background: 'rgba(15,15,30,0.05)', color: 'var(--dash-text-muted)',
              textTransform: 'capitalize',
            }}>{r.kind || '—'}</span>
          },
          { key: 'price', label: 'Price', nowrap: true,
            render: r => `${r.currency || '€'}${Number(r.price || 0).toFixed(2)}` },
          { key: 'sales', label: 'Sales', nowrap: true },
          { key: 'stock', label: 'Stock', nowrap: true,
            render: r => r.stock === null || r.stock === undefined ? '∞' : r.stock },
        ]}
      />
    </div>
  );
}
